import { WDropdown, WTextfield } from '@alice-health/wonderland-react'
import { CSSProperties, FunctionComponent, useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

import { cityOptions } from '@/modules/simulator/constants/city-options'

const CityField: FunctionComponent = () => {
  const dropdownRef = useRef<HTMLWDropdownElement>(null)
  const { register, setValue } = useFormContext()

  useEffect(() => {
    const element = dropdownRef.current

    if (!element) return

    const observer = new ResizeObserver(([entry]) => {
      element.style.setProperty(
        '--city-field-width',
        `${entry.contentRect.width}px`
      )
    })

    observer.observe(element)

    return () => observer.disconnect()
  }, [])

  return (
    <div style={{ '--city-field-width': '350px' } as CSSProperties}>
      <WDropdown
        ref={dropdownRef}
        className='[&_w-list]:!w-[var(--city-field-width)] [&_w-list]:!max-w-[unset]'
        items={cityOptions.map(city => ({
          label: city,
          value: city
        }))}
        /**
         * O `w-change` do `WDropdown` entrega um `WDropdownValue`, que é a união
         * `string | number | object | boolean | Array<...>`. Como os `items`
         * daqui são construídos com `value: city`, na prática só vem string — o
         * guard existe para não gravar no form um valor de outro tipo caso a
         * lista de opções mude de forma.
         */
        onWChange={ev => {
          if (typeof ev.detail === 'string') setValue('city', ev.detail)
        }}
      >
        <WTextfield
          role='combobox'
          className='[&_input]:cursor-pointer'
          {...register('city')}
          placeholder='Escolha a cidade'
          readOnly
          trailingIcon='icChevronArrowDown'
        />
      </WDropdown>
    </div>
  )
}

export { CityField }
